export enum HttpCacheTypes {

    ADD_HTTP_CACHE = "ADD_HTTP_CACHE",
    REMOVE_HTTP_CACHE = "REMOVE_HTTP_CACHE",
    CLEAN_UP_HTTP_CHACHE = "CLEAN_UP_HTTP_CHACHE"

}